import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ERPDataGrid from "../ERPDataGrid";
import "../ERPTheme.css";
import {baseUrl, ipAddress, userName} from "../Univ";
function InventoryTransfer() {
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [owners, setOwners] = useState([]);
    const [editId, setEditId] = useState(null);
    const [workflowList, setWorkflowList] = useState([]);
    const statusList = [{
        value: "PENDING", label: "Pending",
    }, {
        value: "APPROVED", label: "Approved",
    }, {
        value: "COMPLETED", label: "Completed",
    },];
    const [formData, setFormData] = useState({
        from_owner: "",
        to_owner: "",
        transfer_date: new Date().toISOString().slice(0, 10),
        status: "PENDING",
        remarks: "",
        workflow: "",
        addedby: userName,
        ip_add: ipAddress
    });
    useEffect(() => {
        getTransfers();
        getOwners();
        getWorkflows();
    }, []);
    const getWorkflows = () => {
    axios
        .get(baseUrl + "workflow/")
        .then((res) => {
            setWorkflowList(res.data);
        })
        .catch((err) => console.log(err));
};
    const getTransfers = () => {
        setLoading(true);
        axios
            .get(baseUrl + "inventory-transfer/")
            .then((res) => {
                setRows(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const getOwners = () => {
        axios
            .get(baseUrl + "user-profile/")
            .then((res) => {
                setOwners(res.data);
            });
    };
    const handleChange = (e) => {
        setFormData({
            ...formData, [e.target.name]: e.target.value,
        });
    };
    const clearForm = () => {
        setEditId(null);
        setFormData({
            from_owner: "", to_owner: "", status: "PENDING", remarks: "",
        });
    };
    const editData = (row) => {
    setEditId(row.id);

    setFormData({
        from_owner: row.from_owner?.id || "",
        to_owner: row.to_owner?.id || "",
        workflow: row.workflow?.id || "",
        transfer_date: row.transfer_date
            ? row.transfer_date.split("T")[0]
            : "",
        status: row.status || "",
        remarks: row.remarks || "",
    });
};
    const deleteData = (id) => {
        Swal.fire({
            title: "Delete Transfer?", icon: "warning", showCancelButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axios
                    .delete(`delete-inventory-transfer/${id}/`)
                    .then(() => {
                        Swal.fire("Deleted", "", "success");
                        getTransfers();
                    });
            }
        });
    };
   const saveData = async (e) => {

    e.preventDefault();

    setLoading(true);

    try{

        const data=new FormData();

        data.append("from_owner",formData.from_owner);

        data.append("to_owner",formData.to_owner);

        data.append("transfer_date",formData.transfer_date);

        data.append("status",formData.status);
        const inventoryTransferWorkflow = workflowList.find(
                w => w.document_type === "InventoryTransfer"
            );

            if (inventoryTransferWorkflow) {
                data.append("workflow", inventoryTransferWorkflow.id);
            }
        data.append("remarks",formData.remarks);

        data.append("addedby",userName);

        data.append("ip_add",ipAddress);

        if(editId===null){

            await axios.post(
                baseUrl+"inventory-transfer/",
                data
            );

        }

        else{

            await axios.put(
                baseUrl+`update-inventory-transfer/${editId}/`,
                data
            );

        }

        Swal.fire(
            "Success",
            "Transfer Saved",
            "success"
        );

        clearForm();

        getTransfers();

    }

    catch{

        Swal.fire(
            "Error",
            "Unable to Save",
            "error"
        );

    }

    setLoading(false);

};
    const columns = [{
        field: "from_owner", headerName: "From Owner", width: 220, renderCell: (params) => (<>
                {params.row.from_owner ? params.row.from_owner.name : "-"}
            </>)
    }, {
        field: "to_owner", headerName: "To Owner", width: 220, renderCell: (params) => (<>
                {params.row.to_owner ? params.row.to_owner.name : "-"}
            </>)
    }, {
        field: "status", headerName: "Status", width: 150
    }, {
        field: "remarks", headerName: "Remarks", width: 300
    }, {
        field: "action", headerName: "Action", width: 180, renderCell: (params) => (<>

                <button
                    className="btn btn-success btn-sm me-2"
                    onClick={() => editData(params.row)}
                >
                    Edit
                </button>

                <button
                    className="btn btn-danger btn-sm"
                    onClick={() => deleteData(params.row.id)}
                >
                    Delete
                </button>

            </>)
    }];
    return (<div className="container-fluid mt-3">

            <div className="card shadow">

                <div className="card-header bg-success text-white">

                    <h5 className="mb-0">
                        Inventory Transfer
                    </h5>

                </div>

                <div className="card-body">

                    <form onSubmit={saveData}>

                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label>
                                    From Owner
                                </label>

                                <select
                                    className="form-control"
                                    name="from_owner"
                                    value={formData.from_owner}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Owner
                                    </option>

                                    {owners.map((owner) => (<option
                                            key={owner.id}
                                            value={owner.id}
                                        >
                                            {owner.name}
                                        </option>))}

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    To Owner
                                </label>

                                <select
                                    className="form-control"
                                    name="to_owner"
                                    value={formData.to_owner}
                                    onChange={handleChange}
                                    required
                                >

                                    <option value="">
                                        Select Owner
                                    </option>

                                    {owners.map((owner) => (<option
                                            key={owner.id}
                                            value={owner.id}
                                        >
                                            {owner.name}
                                        </option>))}

                                </select>

                            </div>


                            <div className="col-md-4 mb-3">

                                <label>
                                    Status
                                </label>

                                <select
                                    className="form-control"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                >

                                    {statusList.map((status) => (<option
                                            key={status.value}
                                            value={status.value}
                                        >
                                            {status.label}
                                        </option>))}

                                </select>

                            </div>

                            <div className="col-md-3">

                                <label>Transfer Date</label>

                                <input

                                    type="date"

                                    className="form-control"

                                    name="transfer_date"

                                    value={formData.transfer_date}

                                    onChange={handleChange}

                                />

                            </div>
                            <div className="col-md-12 mb-3">


                                <label>

                                    Remarks

                                </label>


                                <textarea


                                    className="form-control"


                                    rows="4"


                                    name="remarks"


                                    value={formData.remarks}


                                    onChange={handleChange}


                                />


                            </div>


                            <div className="col-md-12 mt-3">


                                <button


                                    type="submit"


                                    className="btn btn-success me-2"


                                    disabled={loading}


                                >


                                    {editId === null ? "Save Transfer" : "Update Transfer"}


                                </button>


                                <button


                                    type="button"


                                    className="btn btn-secondary"


                                    onClick={clearForm}


                                >


                                    Clear


                                </button>


                            </div>


                        </div>


                    </form>


                </div>


            </div>

            <div className="card shadow mt-3">


                <div className="card-header bg-primary text-white">


                    <h5 className="mb-0">

                        Inventory Transfer List

                    </h5>


                </div>


                <div className="card-body">


                    <div

                        style={{
                            height: 600, width: "100%"
                        }}

                    >


                        <ERPDataGrid


                            rows={rows}


                            columns={columns}


                            loading={loading}


                            getRowId={(row) => row.id}


                            pageSizeOptions={[10, 25, 50, 100]}


                            disableRowSelectionOnClick


                        />


                    </div>


                </div>


            </div>


        </div>);
}
export default InventoryTransfer;